import axios from 'axios';

const apiURL = process.env.REACT_APP_API_URL;

export interface Employee {
    employeeId: number;
    employeeName: string;
    position: string | null;
    subcontractor: boolean;
    sortOrder: number | null;
    sageDepartment: string | null;
    adminRole: boolean;
    email: string | null;
    worktypeDefaultId: number | null;
    worktypeDefault: any | null;
    worktypegroupDefaultId: number | null;
    worktypegroupDefault: any | null;
    hourlyRate: number | null;
    mobilePhone: string | null;
    vehicleRegistration: string | null;
    permissions: any | null;
    fcmTokens: any[];
    type: string | null;
}

export interface Role {
    roleId: number;
    name: string;
    description: string | null;
    area: string;
    permission: string;
}

// Security groups give their members the group's roles. Distribution groups
// are only lists of people, for sending notifications to, and grant nothing.
export type GroupType = 'Security' | 'Distribution';

export const GROUP_TYPE_OPTIONS = [
    { label: 'Security - members get the group\'s permissions', value: 'Security' },
    { label: 'Distribution - for notifications only, grants no permissions', value: 'Distribution' },
];

export interface Group {
    groupId: number;
    name: string;
    description: string;
    groupType: GroupType;
    employees: Employee[];
    roles: Role[];
}

export interface CreateGroupPayload {
    name: string;
    description: string;
    groupType: GroupType;
    employeeIds: number[] | null;
    roleIds: number[] | null;
}

export interface UpdateGroupPayload {
    groupId: number;
    name: string;
    description: string;
    groupType: GroupType;
    employeeIds: number[] | null;
    roleIds: number[] | null;
}

export const getGroups = async (): Promise<Group[]> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/group`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    return response.data;
};

export const getGroupById = async (groupId: number): Promise<Group> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    const response = await axios.get(`https://${apiURL}/group/${groupId}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });

    return response.data;
};

export const createGroup = async (data: CreateGroupPayload): Promise<void> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    await axios.post(`https://${apiURL}/group`, data, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });
};

export const updateGroup = async (data: UpdateGroupPayload): Promise<void> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    await axios.put(`https://${apiURL}/group/${data.groupId}`, data, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });
};

export const deleteGroup = async (groupId: number): Promise<void> => {
    const token = localStorage.getItem('authToken');

    if (!token) {
        throw new Error('Authorization token not found');
    }

    await axios.delete(`https://${apiURL}/group/${groupId}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
        },
    });
};
